<script>
  import Upload from '@/components/Upload';
  import FormInput from '@/components/Form/Input';
  import ProfilePlaceholder from '@/assets/profile-placeholder.svg';

  export default {
    components: {
      Upload,
      FormInput,
      ProfilePlaceholder,
    },

    data: () => ({
      form: {
        address: 'Rua teste',
        name: 'Lucas Leandro',
        cpf: '000.000.000-00',
        phone: '48 9 9999 9999',
        email: 'lucasleandro1204@gmail.com',
      },
    }),
  };
</script>

<template>
  <main class="account-profile">
    <h1 class="sidebar__title">Dados da conta</h1>

    <article class="row">
      <section class="account-profile__upload">
        <Upload>
          <ProfilePlaceholder />
        </Upload>
      </section>

      <form class="account-profile__form">
        <FormInput
          floating
          type="text"
          v-model="form.name"
          label="Nome Completo"
          />

        <FormInput
          floating
          type="text"
          label="CPF"
          v-model="form.cpf"
          />

        <FormInput
          floating
          type="email"
          label="E-mail"
          v-model="form.email"
          />

        <FormInput
          floating
          type="text"
          v-model="form.phone"
          label="Telefone"
          />

        <FormInput
          floating
          type="text"
          label="Endereço"
          v-model="form.address"
          />

        <button
          @click.prevent
          class="account-profile__action"
          >
          Atualizar dados
        </button>
      </form>
    </article>
  </main>
</template>

<style lang="scss">
  .account-profile {

    &__upload {
      margin-right: 48px;
    }

    &__form {
      width: 100%;
      display: flex;
      max-width: 660px;
      flex-direction: column;
    }

    &__action {
      color: #FFF;
      margin-top: 16px;
      padding: 12px 24px;
      border-radius: 4px;
      align-self: flex-end;
      letter-spacing: 0.32px;
      background-color: #3e388b;

      &:hover {
        background-color: #322c76;
      }
    }

    .upload {
      &__display {
        padding: 0;
        width: 153px;
        height: 153px;
        border-radius: 50%;
      }

      &__image {
        padding: 0;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: contain;
        }
      }
    }

    .form-input--focus .form-input__label--floating {
      background-color: #26273f;
    }
  }
</style>
